export default "__VITE_ASSET__DweWadCz__"